export default {
  props: ['id'],
  data() {
    return {
      qty: 1,
      dialog: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    product() {
      return this.$store.state.shop.product || {};
    },
  },
  methods: {
    AddToCart(item) {
      const payload = item;
      payload.qty = this.qty;
      this.$store.dispatch('shop/AddToCart', payload);
      this.dialog = true;
    },
    ChangeQty(e) {
      this.qty = +e.target.value ? +e.target.value : (this.qty = 1);
    },
    GoToCart() {
      this.$router.push('/cart');
    },
    increment() {
      this.qty = parseInt(this.qty, 10) + 1;
    },
    decrement() {
      this.qty > 1 ? this.qty = parseInt(this.qty, 10) - 1 : false;
    },
  },
  created() {
    this.$store.dispatch('shop/GetProduct', { product_id: this.$props.id })
      .catch(() => {
        setTimeout(() => {
          this.$router.push('/shop');
        }, 500);
      });
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Описание');
  },
};
